module.exports = __webpack_public_path__ + "static/media/orders.391fe954.svg";